import type { ComponentType } from 'react';
import LayoutWrapper from './LayoutWrapper';
import PromptUploadProvider from './PromptUploadProvider';
import PromptUploadListener from './PromptUploadListener';
import type { LayoutType } from './layoutTypes';

type DecoratedRouteProps = {
  LoadedRoute: ComponentType<Record<string, never>> | null;
  layout: LayoutType;
  hasFooterFixedToBottom?: boolean;
  hasFooter?: boolean;
};

function DecoratedRoute({
  LoadedRoute,
  layout,
  hasFooterFixedToBottom = false,
  hasFooter = false,
}: DecoratedRouteProps) {
  if (!LoadedRoute) {
    return null;
  }

  return (
    <LayoutWrapper layout={layout} hasFooter={hasFooter} hasFooterFixedToBottom={hasFooterFixedToBottom}>
      <PromptUploadProvider>
        <PromptUploadListener>
          <LoadedRoute />
        </PromptUploadListener>
      </PromptUploadProvider>
    </LayoutWrapper>
  );
}

export default DecoratedRoute;
